import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/articles/$id")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-article-editor", path: "/admin/articles/$id", title: "Cloud Admin Article Editor", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><ArticleEditor /></AdminLayout>,
});
